import { cn } from '@/lib/utils'
import { LucideIcon } from 'lucide-react'
import { DynamicIcon, IconName } from 'lucide-react/dynamic'

interface IconBadgeProps {
  icon?: LucideIcon
  dynamic?: IconName
  className?: string
  iconClassName?: string
}

const IconBadge = ({ icon: Icon, dynamic, className, iconClassName }: IconBadgeProps) => (
  <div className={cn('bg-icon rounded-full p-1.5', className)}>
    {dynamic && (
      <DynamicIcon
        name={dynamic}
        className={cn('text-icon-foreground size-4 md:size-5', iconClassName)}
        strokeWidth={1.5}
      />
    )}
    {Icon && (
      <Icon
        className={cn('text-icon-foreground size-4 md:size-5', iconClassName)}
        strokeWidth={1.5}
      />
    )}
  </div>
)

export default IconBadge
